import { Modal } from "react-bootstrap";
import React from "react";
import { ReactComponent as Whiteclose } from "../../assets/images/white-close.svg";
import ReactPlayer from "react-player";
import YoutubePlayer from "react-player/youtube";

class VideoModal extends React.Component {
  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.hideModal}
        backdrop="static"
        keyboard={false}
        centered
        id="video-modal"
      >
        <div className="video-modal">
          <div className="modal-close">
            <Whiteclose className="closeicon" onClick={this.props.hideModal} />
          </div>
          {this.props.source.includes("youtube.com") ||
          this.props.source.includes("youtu.be") ? (
            <YoutubePlayer
              url={this.props.source}
              controls
              // height={"100%"}
              // width={"100%"}
              className="video-modals"
            />
          ) : (
            <ReactPlayer
              url={this.props.source}
              controls
              // height={"100%"}
              // width={"100%"}
              className="video-modals"
            />
          )}
          {/* <img
            src={require("../../assets/images/About.png")}
            className="image-modal"
          /> */}
        </div>
      </Modal>
    );
  }
}

export default VideoModal;
